<template>

    <card
        v-if="visit"
        :loading="loading"
        :maxWidth="'auto'"
        :width="'100%'"
        class="card"
    >

      <div class="top-user-block">
        <div class="top-user-block__photo">
          <letters-avatar :name="visit.user && visit.user.name ? visit.user.name : ''" size="60" type="big"/>
        </div>
        <div class="top-user-block__text text-block">
          <div class="text-block__name"> {{ visit.user.name }} <span>{{ visit.id }}</span></div>
          <div class="text-block__subtitle"> {{ visit.user.age | age }} •
            {{              visit.user.gender_type | genderTitle            }}
            •
            id{{ visit.user.id }}
          </div>
        </div>
      </div>

      <div class="user-data" v-if="visit !== {}">
        <div class="user-data__item">
          <div class="user-data__title">Телефон</div>
          <div class="user-data__data">
            <i class="el-icon-phone-outline"></i> {{ visit.user.phone }}
          </div>
        </div>

        <div class="user-data__item">
          <div class="user-data__title">Центр</div>
          <div class="user-data__data" v-if="visit.department">
            {{  visit.department.title }}
          </div>
        </div>
        <div class="user-data__item">
          <div class="user-data__title">Время визита</div>
          <div class="user-data__data">
            {{ $root.dateDefault(visit.date_start) }}
            <span class="user-data__data_span">с</span
            >{{
              $root.timeIso(visit.date_start)
            }}<span class="user-data__data_span">до</span
          >{{ $root.timeIso(visit.date_end) }}
          </div>
        </div>

        <div class="user-data__item">
          <div class="user-data__title">Специалист</div>
          <div class="user-data__data">{{ visit.worker.name }} </div>
        </div>
      </div>


    </card>

</template>

<script>
import LettersAvatar from "@/components/elements/LettersAvatar";
import Card from "@/components/elements/Card.vue"

export default {
  name: "UserInfo",
  components: {
    LettersAvatar,
    Card
  },
  props: {
    visit: {},
    loading: Boolean,
  },
  data: function () {
    return {};
  },
  computed: {},
  methods: {},
  filters: {
    genderTitle(type) {
      let title = ''
      if (type == 'male') title = 'мужской';
      if (type == 'female') title = 'женский';
      return title
    },
    age(n) {
      let arr = ["год", "года", "лет"];
      return (
          n +
          " " +
          arr[
              n % 100 > 4 && n % 100 < 20
                  ? 2
                  : [2, 0, 1, 1, 1, 2][n % 10 < 5 ? n % 10 : 5]
              ]
      )
    },
  }
};
</script>

<style scoped lang="scss">
.card {
  margin: 24px 0 0 0;
  padding: 32px 48px;
}
.user-data {

  border-top: 1px solid #EAEAEA;
  padding-top: 32px;

  display: flex;
  align-items: flex-start;
  width: 100%;



  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 32px 0 16px 0;


  &__name {
    margin-top: 5px;
    color: #8e8e93;

    font-weight: 500;
    font-size: 15px;
    line-height: 100%;
  }


  &__item {
    margin-right: 50px;
  }

  &__data {
    font-size: 13px;
    line-height: 16px;

    color: #111;
    margin-top: 10px;

    &_span {
      background: #b7bac0;
      border-radius: 2px;
      padding: 0px 5px;
      margin: 0 4px;

      color: #fff;
      font-size: 11px;
    }
  }



  &__title {
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    color: #111;
  }
}



.top-user-block {
  display: flex;
  align-items: center;

  &__photo {

  }

  &__text {
    margin-left: 17px;
  }

  .text-block {

    &__name {
      display: flex;
      align-items: baseline;

      font-weight: 600;
      font-size: 24px;

      color: #111;

      span {
        margin-left: 7px;

        font-weight: 600;
        font-size: 16px;
        line-height: 26px;
        color: #8E8E93;
      }

    }

    &__subtitle {
      margin-top: 11px;
      font-size: 15px;

      color: #8E8E93;
    }
  }
}

</style>
